import { COVERGO_SAAS_PROD } from "../consts.js"

export const icbl = {
	"icbl-uat-studio.quote.hk": {
		appConfig: {
			tenantId: "icbl",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_SAAS_PROD
	}
}
